module.exports = __webpack_public_path__ + "static/media/oinswap.cbd61425.svg";